let _navigate = null;

export const setNavigator = (navigate) => {
  _navigate = navigate;
};

export const navigate = (...args) => {
  if (_navigate) _navigate(...args);
};
